(function () {
  'use strict';

  /* Mobile menu */
  var menuBtn = document.getElementById('menu-btn');
  var menu = document.getElementById('mobile-menu');
  if (menuBtn && menu) {
    var openMenu = function () {
      menu.classList.add('open');
      menu.setAttribute('aria-hidden', 'false');
      menuBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    };
    var closeMenu = function () {
      menu.classList.remove('open');
      menu.setAttribute('aria-hidden', 'true');
      menuBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    };
    menuBtn.addEventListener('click', openMenu);
    menu.querySelectorAll('[data-menu-close]').forEach(function (el) {
      el.addEventListener('click', closeMenu);
    });
    menu.querySelectorAll('nav a').forEach(function (a) {
      a.addEventListener('click', closeMenu);
    });
  }

  /* Tabs: Mais Vendidos / Todos */
  var grids = {
    'mais-vendidos': document.getElementById('grid-mais-vendidos'),
    'todos': document.getElementById('grid-todos')
  };
  var tabButtons = document.querySelectorAll('[data-tab-btn]');
  var sectionTitle = document.getElementById('section-title');
  function setTab(tab) {
    if (!grids[tab]) tab = 'mais-vendidos';
    Object.keys(grids).forEach(function (k) {
      if (grids[k]) grids[k].classList.toggle('hidden', k !== tab);
    });
    tabButtons.forEach(function (b) {
      var on = b.getAttribute('data-tab-btn') === tab;
      b.classList.toggle('active', on);
      b.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    if (sectionTitle) sectionTitle.textContent = tab === 'todos' ? 'Todos os Produtos' : 'Mais Vendidos';
  }
  tabButtons.forEach(function (b) {
    b.addEventListener('click', function () {
      var tab = b.getAttribute('data-tab-btn');
      setTab(tab);
      var url = new URL(window.location.href);
      url.searchParams.set('tab', tab);
      window.history.replaceState({}, '', url);
    });
  });
  var initialTab = new URLSearchParams(window.location.search).get('tab');
  if (initialTab) setTab(initialTab);

  /* Product gallery thumbs */
  var mainImage = document.getElementById('main-image');
  document.querySelectorAll('[data-thumb-src]').forEach(function (t) {
    t.addEventListener('click', function () {
      if (mainImage) mainImage.src = t.getAttribute('data-thumb-src');
      document.querySelectorAll('.thumb').forEach(function (x) { x.classList.remove('active'); });
      t.classList.add('active');
    });
  });

  /* Variant price update */
  var variantSelect = document.getElementById('variant-select');
  if (variantSelect && window.PRODUCT_VARIANTS) {
    var fmt = function (cents) {
      try {
        return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(cents / 100);
      } catch (e) {
        return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',');
      }
    };
    var updateVariant = function () {
      var v = window.PRODUCT_VARIANTS.find(function (x) { return String(x.id) === variantSelect.value; });
      if (!v) return;
      var priceEl = document.getElementById('price');
      if (priceEl) priceEl.textContent = fmt(v.price);
      var inst = document.getElementById('installment');
      if (inst) inst.textContent = fmt(v.price / 12);
      var cmp = document.getElementById('price-compare');
      var off = document.getElementById('price-off');
      if (cmp && off) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          cmp.textContent = fmt(v.compare_at_price);
          cmp.style.display = '';
          off.textContent = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '% Off';
          off.style.display = '';
        } else {
          cmp.style.display = 'none';
          off.style.display = 'none';
        }
      }
    };
    variantSelect.addEventListener('change', updateVariant);
  }

  /* Cart: auto refresh on quantity change */
  var cartForm = document.querySelector('form[action*="/cart"]');
  if (cartForm) {
    cartForm.querySelectorAll('input[name="updates[]"]').forEach(function (input) {
      input.addEventListener('change', function () { cartForm.submit(); });
    });
  }
})();
